























import { Component, Prop, Vue } from 'vue-property-decorator';
import TransitionPicker from '@/features/bots/components/designer/TransitionPicker.vue';
import TagBox from '@/shared/components/TagBox.vue';
import { validationMixin } from 'vuelidate';
import { mixin as clickaway } from 'vue-clickaway';
import { required } from 'vuelidate/lib/validators';
import { StateViewModel } from '@/features/bots/models/designer/stateViewModel';
import IslandBadge from './IslandBadge.vue';
import { TransitionViewModel } from '@/features/bots/models/designer/transitionViewModel';
import ErrorIcon from 'vue-material-design-icons/AlertCircleOutline.vue';
import { Getter } from 'vuex-class';

@Component({
	mixins: [clickaway, validationMixin],
	components: {
		TagBox,
		TransitionPicker,
		IslandBadge,
		ErrorIcon
	},
	validations: {
		state: {
			transition: {
				required,
				type: {
					required
				},
				payload: {
					payloadValid(payload: string) {
						const component = (this as any);
						if (payload) {
							return !component.isTransitionPayloadInvalid(payload);
						}
						return true;
					}
				}
			}
		}
	}
})
export default class GoToComponent extends Vue {
	@Prop() public value: StateViewModel;
	@Getter public isTransitionPayloadInvalid: (payload: string) => boolean;

	public state: StateViewModel = {
		id: '',
		component: 'GoTo'
	};

	public invalid: boolean = true;

	public mounted() {
		if (this.value) {
			this.state = this.value;
			this.invalid = this.state.invalid ?? false;
		}
	}

	public updateTransition(transition: TransitionViewModel) {
		this.state.transition = transition;
		this.emitUpdatedEvent();
	}

	public validateGoTo() {
		this.$v.state.$touch();
	}

	private emitUpdatedEvent() {
		this.invalid = this.$v!.state!.transition!.$invalid;
		this.state.invalid = this.invalid;
		this.$emit('state-updated', this.state);
	}
}
